import React, { useMemo } from 'react';

export function ResultColumns(event_category) {


  const breedDisplay = (row) => row?.breed_display || row.dog_data?.breed || ''; // Assume backend provides processed breed

  const specialClasses = [
    'Steeplechase 1',
    'Steeplechase 2',
    'Steeplechase 3',
    'Jumps and Tunnels 1',
    'Jumps and Tunnels 2',
    'Jumps and Tunnels 3',
  ];

  const columnsByCategory = {
    'Agility Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, sortable: false, wrap: true, grow: 2 },
      { name: 'Level', selector: row => row.level, sortable: true, wrap: true },
      { name: 'Division', selector: row => row.division, sortable: true, wrap: true },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      {
        name: 'Score',
        selector: row => specialClasses.includes(row.class) ? row.pass_or_fail : row.score,
        wrap: true
      },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),
    'Beagle Field Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Points', selector: row => row.points, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),
    'Chase Ability Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),
    'Draft Dog Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail A', selector: row => row.pass_or_fail_a || '', wrap: true },
      { name: 'Pass or Fail B', selector: row => row.pass_or_fail_b || '', wrap: true },
      { name: 'Pass or Fail C', selector: row => row.pass_or_fail_c || '', wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
      { name: 'Judge C', selector: row => row.judge_C, wrap: true },
    ], []),
    'Earthdog Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),
    'Herding Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Division', selector: row => row.division, wrap: true },
      { name: 'Level  ', selector: row => row.level, wrap: true },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Score', selector: row => row.score, wrap: true },
      {
        name: 'Pass or Fail', selector: row => {
          // If there's a score greater than 0, suppress "NA" display
          const score = parseFloat(row.score || 0);
          if (score > 0 && row.pass_or_fail === 'NA') {
            return ''; // Suppress NA when score > 0
          }
          return row.pass_or_fail || '';
        }, wrap: true
      },
      { name: 'Points', selector: row => row.points, wrap: true },
      { name: 'Points 2', selector: row => row.points2, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),
    // Add more for other categories as per doc, similar pattern.
    // For example:
    'Pointing Field Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Points', selector: row => row.points, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),
    // ... add for all categories from doc.
    'Other': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },

      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),
    'Lure Coursing Field Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Points', selector: row => row.points ? row.points : "-", wrap: true },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
      { name: 'Judge C', selector: row => row.judge_C, wrap: true },
    ], []),

    'Pointing Field Dog Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Score', selector: row => row.score, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),

    'Pointing Water Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Score', selector: row => row.score ? row.score : row?.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),

    'Retriever Field Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      { name: 'Points', selector: row => row.points, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),

    'Retriever Hunt Test': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),

    'Working Certificate Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),

    'Scent Detection': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Division', selector: row => row.division, wrap: true },
      { name: 'Level', selector: row => row.level, wrap: true },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),

    'Spaniel Field Trials': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Placement', selector: row => row.placement, wrap: true },
      {
        name: 'Points',
        selector: row => {
          const className = (row.class || "").trim().toLowerCase();

          // For Water Test → display Pass/Fail
          if (className === "water test") {
            return row.result || "PASS";
          }
          // For all other classes → display numeric points
          return row.points;
        },
        wrap: true,
      },

      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),

    'Spaniel Hunt Test': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge A', selector: row => row.judge_A, wrap: true },
      { name: 'Judge B', selector: row => row.judge_B, wrap: true },
    ], []),

    'Sprinter': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Division', selector: row => row.division, wrap: true },
      { name: 'Level', selector: row => row.level, wrap: true },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Score', selector: row => row.score, wrap: true },
    ], []),

    'Tracking Tests': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),

    'Canine Good Neighbour': useMemo(() => [
      { name: 'Class or Stake', selector: row => row.class, wrap: true, grow: 2 },
      { name: 'Dog Name', selector: row => row.dog_data?.dog_title ? row.dog_data?.dog_title : row.dog_data?.dog_name, wrap: true, grow: 3 },
      { name: 'Breed', selector: breedDisplay, wrap: true, grow: 2 },
      { name: 'Pass or Fail', selector: row => row.pass_or_fail, wrap: true },
      { name: 'Judge', selector: row => row.judge, wrap: true },
    ], []),


  };

  return columnsByCategory[event_category] || columnsByCategory['Other'];
}

















